import {FILESUPLOADED,CREATECASE_SUCCESS,CREATECASE_FAILED,CREATECASE_RESET,GETFILELINK} from '../constants';
const INITIAL_STATE = {};
export default (state = INITIAL_STATE,action)=>{
  switch(action.type){
    case FILESUPLOADED:
      return action.payload;
    case CREATECASE_SUCCESS:
      return action.payload;
    case CREATECASE_FAILED:
      return action.payload;
    case CREATECASE_RESET:
      return action.payload;
    case GETFILELINK:
      return action.payload
    default:
      return state;
  }
}
